import React, { useRef } from "react";

const UploadRow = ({title, className, isExists, onUpload, accept}:{title:string, className?:string, isExists?:boolean, onUpload: (file:File) => void, accept:string}) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleUploadClick = () => {
        fileInputRef.current?.click(); // trigger hidden input
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            console.log("Selected file:", file);
            // You can handle upload logic here
            onUpload(file)
        }
    };

    return (
        <div className={`position-relative border border-primary rounded p-5 d-flex justify-content-between align-items-center ${className && className}`}>
            <h4 className="mb-0">{title}</h4>
            <div className="d-flex gap-4">
                <button
                    type="button"
                    className="btn border border-2 btn-light w-100"
                    onClick={handleUploadClick}
                >
                    Upload/Replace
                </button>
                {isExists && <div data-bs-toggle="tooltip" data-bs-placement="top" title="This Item has Animation" className="cursor-pointer w-20px h-20px rounded-circle position-absolute" style={{top: '-10px', right: '-10px', backgroundColor: 'green'}}></div>}
                {/* Hidden file input */}
                <input
                    type="file"
                    accept={accept}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
            </div>
        </div>
    );
};

export default UploadRow;
